import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Store } from '@ngrx/store';
import { combineLatest, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { esignActions, esignSelectors } from 'src/app/root-store';
import { TemplateSearchParameters } from '../models/template-search-parameters.model';
import { Template } from '../models/template.model';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
    selector: 'nova-template-grid',
    templateUrl: './template-grid.component.html',
    styleUrls: ['./template-grid.component.scss']
})
export class TemplateGridComponent implements OnInit {
    @Output() selectedTemplate = new EventEmitter<Template>();

    templates$: Observable<Template[]>;
    searchText = new UntypedFormControl('');
    templateSelect = new UntypedFormControl('');
    searchResultText: string;
    displayedColumns: string[] = ['select', 'name', 'pageCount', 'preview'];

    constructor(private readonly _store: Store) {}

    ngOnInit(): void {
        this.templates$ = combineLatest([
            this._store.select(esignSelectors.selectTemplateSearchResult),
            this._store.select(esignSelectors.selectTemplateSearchParameters)
        ]).pipe(
            untilDestroyed(this),
            tap(([templates, searchParams]) => this.buildSearchResultString(searchParams, templates?.length)),
            map(([templates]) => templates ?? [])
        );

        this.templateSelect.valueChanges.pipe(untilDestroyed(this)).subscribe((value) => {
            this.selectedTemplate.emit(value);
        });
    }

    getTemplateImage(externalTemplateId: string, templateName: string): void {
        this._store.dispatch(
            esignActions.EsignActions.getTemplateImage({
                externalTemplateId: externalTemplateId,
                templateName: templateName
            })
        );
    }

    isTemplateCompatible(template: Template): boolean {
        return template?.docCount === 1;
    }

    private buildSearchResultString(searchParams: TemplateSearchParameters, templateCount: number) {
        if (searchParams.searchText) {
            this.searchResultText = `${templateCount ?? 0} results for "${searchParams.searchText}" `;
            this.searchResultText += searchParams.searchAllFolders ? 'in all folders' : 'within folder';
        } else {
            this.searchResultText = null;
        }
    }
}
